import { trackingLabel, trackingLink } from './tracking.link';

/**
 * A tracking number, as a link where one can be built.
 *
 * The same component on both sides, so TAP and the factory follow the same
 * shipment to the same page. Plain text when there is nowhere to send anyone —
 * a guessed URL that 404s on a courier's site reads as the shipment being
 * lost, which is a worse thing to imply than "we have no link".
 */
export function TrackingValue({
  courier,
  tracking,
  url,
}: {
  courier: string;
  tracking: string | null;
  url: string;
}) {
  const label = trackingLabel(courier, tracking);
  if (label === '') {
    return null;
  }
  const href = trackingLink(courier, tracking, url);
  if (href === null) {
    return <>{label}</>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {label} ↗
    </a>
  );
}
